(function () {

    angular
        .module('smartertoolsApp')
        .controller('haBillingReportController',
            [
                '$stateParams', '$scope', '$q', '$timeout', 'highAvailabilityPartnerService', 'partnerService', 'notificationFactory', 'authenticationService', haBillingReportController
            ]);

    function haBillingReportController($stateParams, $scope, $q, $timeout, highAvailabilityPartnerService, partnerService, notify, authenticationService) {
        const vm = this;
        vm.licenseId = $stateParams.licenseId;

        // Functions


        activate();

        // -----------------------------------------------

        function activate() {
            refreshData();
        }

        function refreshData() {
            $scope.accountCtrl.isLoading++;
            highAvailabilityPartnerService.getActiveLicenses()
                .then(
                    (licenses) => {
                        vm.licenses = licenses;
                        vm.license = licenses.find(l => l.LicenseId == vm.licenseId);
                        $scope.accountCtrl.isLoading--;
                    }
                )
                .catch((e) => {
                    if (e.status == 403) {
                        window.location.href = '/company/partners';
                        return;
                    }
                    $scope.accountCtrl.isLoading--;
                    notify.error('There was a problem loading this information.  Please try again later.');
                });

            // Load license and callback data and billing info 


        }
    }

})();        